import React from 'react';

export default function CustomFeatures() {
  return (
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Custom_Feature__CncZcohCQqm5D4uvpr7ETQ"
      height="640"
      title="Custom Features"
      allowFullScreen
    />
  );
}
